import remoteConfigData from "@/settings/remoteConfigData";

function remoteConfig(key) {
  const remoteConfig = localStorage.getItem("remoteConfig")
    ? JSON.parse(localStorage.getItem("remoteConfig"))
    : remoteConfigData;

  const configValue = remoteConfig[key];
  if (
    typeof configValue === "string" &&
    (configValue.startsWith("[") || configValue.startsWith("{"))
  ) {
    return JSON.parse(configValue); // config value can be JSON string
  } else {
    return configValue;
  }
}

export { remoteConfig };
